import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PuzzleService } from '../../../shared/services/puzzle.service';
import {
  ChessboardFun,
  chessBoard,
  clearCanvas,
  drawArrow,
  initializeCanvas,
} from '../../../shared/functions/chessboardMain';
import {
  highlightLastMove,
  resetChess,
  undoMove,
  updateBoard,
} from '../../../shared/functions/onDrop';
import { game } from '../../../shared/functions/chess';
import { ChessBoard } from '../../../shared/js/chess';
import { Router } from '@angular/router';
import { DecryptionService } from '../../../shared/services/decryption.service';

@Component({
  selector: 'app-complated-puzzle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './complated-puzzle.component.html',
  styleUrl: './complated-puzzle.component.scss',
})
export class ComplatedPuzzleComponent implements OnInit, AfterViewInit {
  puzzleRecord: any[] = [];
  pageNumber = 1;
  isLoading = false;
  puzzleTableData: any;
  selectedPuzzle: any;
  currentMoveIndex = 0;
  customclassPuzzleBoard = '';
  chessboard: any;
  constructor(private PuzzleApi: PuzzleService, private elRef: ElementRef, private router: Router,private decryptionApi: DecryptionService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    ChessboardFun();
    resetChess();
    this.complatedPuzzle();
    initializeCanvas(this.elRef);
  }

  complatedPuzzle() {
    this.PuzzleApi.complatepuzzle(this.pageNumber).subscribe({
      next: (res) => {
        const decrypt=  this.decryptionApi.decrypt(res.payload);
        const jsondecrpt=JSON.parse(decrypt);
        if (jsondecrpt) {
          this.isLoading = false;
        }
        this.puzzleTableData = jsondecrpt;
        this.puzzleRecord.push(...this.puzzleTableData);
        this.selectedPuzzle = this.puzzleRecord[0];
        this.puzzleSelectID(this.selectedPuzzle);
        if (this.puzzleRecord.length > 15) {
          return (this.customclassPuzzleBoard = 'table-responsive');
        } else {
          return (this.customclassPuzzleBoard = 'table-scroll-responsive');
        }
      },
      error: (err) => {},
    });
  }

  puzzleSelectID(data: any) {
    this.selectedPuzzle = data;
    this.currentMoveIndex = 0;
    clearCanvas();
    highlightLastMove();
    game.load(this.selectedPuzzle.FEN);
    chessBoard.position(game.fen());
    updateBoard();
  }

  onScroll(event: any) {
    const element = event.target as HTMLElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
    if (this.puzzleTableData.length == 0) {
      return;
    }
    if (scrollPosition >= totalHeight - 1) {
      // event.target.offsetHeight + event.target.scrollTop >=
      // event.target.scrollHeight
      this.isLoading = true;
      this.pageNumber++;
      this.complatedPuzzle();
    }
  }

  filpChessBoard() {
    chessBoard.flip();
    updateBoard();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    event.stopPropagation();
    if (
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      event.key === 'F' ||
      event.key === 'f' ||
      event.key === 'R' ||
      event.key === 'r'
    ) {
      event.preventDefault();
      if (event.key === 'ArrowLeft') {
        this.prevMove();
      } else if (event.key === 'ArrowRight') {
        this.nextMove();
      } else if (event.key === 'F' || event.key === 'f') {
        this.filpChessBoard();
        const moves: any = game.history({ verbose: true });
        const lastMove = moves.length ? moves[moves.length - 1] : null;
        lastMove ? drawArrow(lastMove?.from, lastMove?.to) : clearCanvas();
        highlightLastMove(lastMove?.from, lastMove?.to);
      }
    }
  }

  nextMove() {
    const data = this.selectedPuzzle.Moves.split(' ');
    if (this.currentMoveIndex < data.length) {
      const move = data[this.currentMoveIndex];
      const lastMove = game.move(move);
      lastMove ? drawArrow(lastMove?.from, lastMove?.to) : clearCanvas();
      highlightLastMove(lastMove?.from, lastMove?.to);
      chessBoard.position(game.fen());
      updateBoard();
      this.currentMoveIndex++;
    }
  }
  prevMove() {
    if (this.currentMoveIndex > 0) {
      this.currentMoveIndex--;
      undoMove();
      const moves: any = game.history({ verbose: true });
      const lastMove = moves.length ? moves[moves.length - 1] : null;
      lastMove ? drawArrow(lastMove?.from, lastMove?.to) : clearCanvas();
      highlightLastMove(lastMove?.from, lastMove?.to);
    }
    updateBoard();
  }

  puzzleMainroute() {
    resetChess();
    this.router.navigate(['puzzle']);
  }
}
